import React from 'react';

interface CollapseButtonProps {
    direction: 'left' | 'right';
    onClick: () => void;
    className?: string;
}

export const CollapseButton: React.FC<CollapseButtonProps> = ({ direction, onClick, className = '' }) => {
    const arrow = direction === 'left' ? '←' : '→';
    
    return (
        <button 
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            className={`collapse-button ${className}`}
            style={{
                background: 'none',
                border: 'none',
                color: '#666',
                cursor: 'pointer',
                fontSize: '16px',
                padding: '4px',
                borderRadius: '3px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            {arrow}
        </button>
    );
};
